if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

      }

      async getCartData() {
        try {
          const response = await fetch('/cart.js');

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const cartData = await response.json();
          return cartData;
        } catch (error) {
          throw new Error('Error fetching cart data: ' + error.message);
        }
      }


      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

        const formData = new FormData(this.form);

        const idVariant = formData.get('id');

        let data = {
          items: [
            {
              quantity: 1,
              id: idVariant,
            }
          ],
          sections: this.cart.getSectionsToRender().map((section) => section.id),
        };


        const response = await this.cart.addToCartOnly(data, idVariant);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: idVariant, cartData: response });

        this.cart.renderContents(response);

        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        const sliderUpsell = document.querySelector('.content-slider-upsell');
        if (sliderUpsell) {
          new Swiper(sliderUpsell, {
            loop: true,
            slidesPerView: 2,
            spaceBetween: 12,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          });
        }

        // Manejo de clicks en los selectores
        document.querySelectorAll('.selector-open p').forEach(el => {
          el.addEventListener('click', () => {
            el.classList.toggle('active');
            el.closest('.selector-open')?.classList.toggle('active');
            el.closest('.product-variant')?.classList.toggle('active');
            el.parentElement?.parentElement?.parentElement?.classList.toggle('active');
          });
        });

      }



      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
